export const enGbData = {
  advancedFormat: 'Do MMMM YYYY',
  formatString: 'DD/MM/YYYY',
  advancedDayFormat: 'dddd, D MMMM, YYYY',
}

export const enUsData = {
  advancedFormat: 'MMMM Do, YYYY',
  formatString: 'MM/DD/YYYY',
  advancedDayFormat: 'dddd, MMMM D, YYYY',
}

export const localeData = new Map([
  ['en-GB', enGbData],
  ['en-US', enUsData],
])
